// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__v+jGn","split":"Loading_split__v6j2c"};